import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./BrandModal.css";

const Confirm = ({ toggle, setToggle, onConfirm, text }) => {
  const close = () => setToggle(false);

  const handleConfirm = async () => {
    await onConfirm();
    close();
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Confirm</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">{text}</p>
        <div className="brand-modal__actions">
          <button type="button" className="brand-modal__btn brand-modal__btn--danger" onClick={handleConfirm}>
            <FontAwesomeIcon icon={faTrash} /> Delete
          </button>
          <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
            <FontAwesomeIcon icon={faTimes} /> Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Confirm;
